function ApplyToRace() {
  return <section>
    <h1>apply to race</h1>
  </section>
}

export default ApplyToRace